module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Ken N Kamoche was born and raised in Kenya. He was educated at the University of Nairobi and the University of Oxford. He is a management academic, occasional newspaper columnist and writer of fiction. Ken’s collection of short stories, "), _c('em', [_vm._v("A Fragile Hope")]), _vm._v(" (Salt, 2007), was shortlisted for the Commonwealth First Book Award. After travelling frequently to Asia, Ken took up a job in Hong Kong in 1998 supposedly for two years. The two years soon turned into ten, involved extensive travel up and down China, and ultimately inspired this novel.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0